import React from "react";
import Trans from "../intl/Trans";
import MaintenanceErrorIcon from "../../../resources/images/icons/MaintenanceErrorIcon.png";
MaintenanceErrorPage.propTypes = {};
/**
 * This page is rendered inside RouterErrorHandler with public/private layout or
 * directly by ApplicationErrorHandler without layout if getIdentity responded with 503
 */ export default function MaintenanceErrorPage() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex min-h-[calc(100vh-180px)] flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8"
    }, /*#__PURE__*/ React.createElement("img", {
        src: MaintenanceErrorIcon,
        alt: "Maintenance error icon",
        className: "mx-auto mb-8 h-56 w-56 sm:mb-12 sm:h-72 sm:w-72"
    }), /*#__PURE__*/ React.createElement("h1", {
        className: "mb-6 mt-4 text-2xl font-bold dark:text-white"
    }, /*#__PURE__*/ React.createElement(Trans, null, "common.errors.pages.maintenance.title")), /*#__PURE__*/ React.createElement("p", {
        className: "mt-3 text-gray-600 dark:text-gray-400"
    }, /*#__PURE__*/ React.createElement(Trans, null, "common.errors.pages.maintenance.subtitle")));
}
